module.exports = __webpack_public_path__ + "media/images/step3-52814f15.png";